import { InfoCircleTooltip } from 'components/Tooltip/InfoCircleTooltip';
import { SummaryCardTitleContainer } from 'pages/Optimisation/components/SummaryCards/SummaryCardTitle/SummaryCardTitle.styled';
import { CSSProperties, ReactNode } from 'react';

export const SummaryCardTitle = ({
  title,
  tooltip,
  leftContent,
  style = {},
}: {
  title: string;
  tooltip?: ReactNode;
  leftContent?: ReactNode;
  style?: CSSProperties;
}) => {
  return (
    <SummaryCardTitleContainer style={style}>
      <div
        style={{ display: 'flex', alignItems: 'center', width: '100%', gap: 4 }}
      >
        <div>{title}</div>
        {tooltip && <InfoCircleTooltip tooltip={tooltip} />}
      </div>
      {leftContent ? leftContent : null}
    </SummaryCardTitleContainer>
  );
};
